const ExcelIcon = ({ width = '100%', height = '100%', ...props }: any) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.395406 0.395406C0.142232 0.64858 0 0.991958 0 1.35V20.25C0 20.608 0.142232 20.9514 0.395406 21.2046C0.64858 21.4578 0.991958 21.6 1.35 21.6H14.85C15.208 21.6 15.5514 21.4578 15.8046 21.2046C16.0578 20.9514 16.2 20.608 16.2 20.25V6.35445C16.1999 5.99644 16.0576 5.65311 15.8045 5.4L10.8 0.39555C10.5469 0.142359 10.2036 7.64605e-05 9.84555 0H1.35C0.991958 0 0.64858 0.142232 0.395406 0.395406ZM1.35 1.35H9.45V5.4C9.45 5.75804 9.59223 6.10142 9.84541 6.35459C10.0986 6.60777 10.442 6.75 10.8 6.75H14.85V20.25H1.35V1.35ZM10.8 5.4V2.30445L13.8955 5.4H10.8ZM7.2525 16.3998H5.9165L7.6765 13.4958L5.9965 10.7998H7.3565L8.4045 12.6878L9.4445 10.7998H10.8045L9.1245 13.4958L10.8845 16.3998H9.5485L8.4045 14.3438L7.2525 16.3998Z"
      fill="#3BBE5D"
    />
  </svg>
)

export default ExcelIcon
